define('gameday-index-configurator/src/model/valueObjects/SiteConfig',['require','exports','module','jquery','extant/extant'],function(require, exports, module) {
	// required vars
	var $ = require("jquery"),
		exists = require("extant/extant");

	// constants, or some equivelent
	var LOGIN_STATUS = "loginStatus",
		DEFAULT_REFRESH = 60;

	var data = { };

	function SiteConfig(props) {
		$.extend(data, props);
	}

	SiteConfig.prototype = {
		getInitListener: function() {
			return (exists(data.listener)) ? data.listener : null;
		},

		getAdRefreshRate: function() {

			return data.ads && data.ads.refresh || data.adRefreshRate || DEFAULT_REFRESH;
		},
		getAds : function(){
			return data.ads || {
				refresh : data.adRefreshRate || DEFAULT_REFRESH,
				units : data.adUnits || {}
			};
		},
		getAdPlacements: function() {
			return data.ads && data.ads.units || data.adUnits || { };
		},
		
		getMediaService: function() {
			return data.mediaService || { };
		},
		
		getSiteProperty: function() {
			return data.siteProperty || "";
		},

		getTrackingConfig: function(){
			return data.tracking || { };
		},
		getSponsor: function(){
			return data.sponsor || "";
		},
		setLoginStatus: function(state) {
			data[LOGIN_STATUS] = state;
		},
		getLoginStatus: function() {
			return data[LOGIN_STATUS] || false;
		},
		getSecureDomain: function() {
			return data.authentication.secureServer || "";
		}
	};

	return SiteConfig;
});
